// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\np[data-v-1e53567f] {\n  margin-bottom: 0px !important;\n}\n.company[data-v-1e53567f] {\n  padding-top: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
